export default "__VITE_ASSET__BXYvtSYq__"